import React from 'react';
import BoxAcceptableSVG from 'assets/svg/box-acceptable.svg';
import BoxAcceptableOrangeSVG from 'assets/svg/box-acceptable-orange.svg';
import NoBoxAcceptableSVG from 'assets/svg/no-box-acceptable.svg';
import NoInventorySVG from 'assets/svg/no-inventory.svg';
import SuperSpeedSVG from 'assets/svg/super-speed-icon.svg';
export const BoxAcceptableOrange = () => {
  return /*#__PURE__*/React.createElement("img", {
    src: BoxAcceptableOrangeSVG,
    alt: "Icon of an orange gift box with a ribbon on top symbolizing a prize or bonus"
  });
};
export const BoxAcceptable = () => {
  return /*#__PURE__*/React.createElement("img", {
    src: BoxAcceptableSVG,
    alt: "Icon of a pink gift box with a ribbon on top indicating a gift or special reward"
  });
};
export const NoBoxAcceptable = () => {
  return /*#__PURE__*/React.createElement("img", {
    src: NoBoxAcceptableSVG,
    alt: "Icon of a pink gift box with a red prohibition sign, indicating no gifts are allowed or available"
  });
};
export const NoInventory = () => {
  return /*#__PURE__*/React.createElement("img", {
    src: NoInventorySVG,
    alt: "Icon of a blue box with a red prohibition sign, signifying no inventory or prohibited storage"
  });
};
export const SuperSpeed = () => {
  return /*#__PURE__*/React.createElement("img", {
    src: SuperSpeedSVG,
    alt: "Icon of a yellow rocket, representing speed, launch, or fast service"
  });
};